module.exports = "/assets/data/744b9cad4992492b9e1f9d5458b0e7c7-BT43.data.json";